import { Thumbnail } from 'src/modules/materials/components/Thumbnail';
import React, { FC, memo, useContext } from 'react';
import styled from 'styled-components';
import { media } from 'src/styles/designs';
import { GenericSectionHeader } from 'src/modules/materials/components/ShowcasePage/common';
import { AnimatePresence, motion } from 'framer-motion';
import { makeTransition } from 'src/utils/motion/transitions';
import { dirRTL } from 'src/styles/theme';
import { ShowcaseListRenderComponentProps } from 'src/modules/materials/models/showcase';
import { ShowcaseContext } from 'src/modules/materials/providers/ShowcaseContext';

const Grid = styled(motion.ul)`
  display: grid;
  align-content: flex-start;
  align-items: flex-start;
  justify-items: flex-start;
  grid-gap: 20px;
  grid-template-columns: 1fr;

  ${media.w.greaterThanOrEqual.desktop} {
    grid-template-columns: repeat(3, 264px);
    margin-right: calc(-1 * var(--results-right-margin));

    ${dirRTL} {
      margin-right: 0;
      margin-left: calc(-1 * var(--results-right-margin));
    }
  }
`;

export const GridResultSectionRender: FC<ShowcaseListRenderComponentProps> =
  memo(function GridResultSectionRender({ section, items }) {
    const { thumbnailOptions } = useContext(ShowcaseContext);

    return (
      <>
        <motion.div
          {...makeTransition({
            fade: true,
          })}
        >
          <GenericSectionHeader section={section} />
        </motion.div>
        <Grid
          {...makeTransition({
            fade: true,
            stagger: 0.02,
          })}
        >
          <AnimatePresence presenceAffectsLayout>
            {items?.map((item) => (
              <Thumbnail
                item={item}
                uniqueId={item.id + section.name}
                key={item.id}
                as={motion.li}
                layout="position"
                {...thumbnailOptions}
                {...makeTransition({
                  fade: true,
                  from: 'topMore',
                  to: 'bottomLess',
                  speed: 'faster',
                  enterDelay: 0.2,
                  forStagger: true,
                })}
              />
            ))}
          </AnimatePresence>
        </Grid>
      </>
    );
  });
